/** Bracketed placeholders like "[PRICE]" are business facts Rook hasn't filled in (SPEC §17.5). */
export const PLACEHOLDER_RE = /^\[.*\]$/s;

export function isPlaceholder(value: unknown): boolean {
  return typeof value === 'string' && PLACEHOLDER_RE.test(value.trim());
}

/** Format integer cents as dollars, or pass a placeholder through untouched. */
export function money(value: number | string | null | undefined): string {
  if (value === null || value === undefined) return '[PRICE]';
  if (typeof value === 'string') return value;
  const dollars = value / 100;
  return dollars % 1 === 0 ? `$${dollars.toFixed(0)}` : `$${dollars.toFixed(2)}`;
}
